import API from "../../core/apiConfig";
import {
  normalizePaginatedResponse,
  type ServiceQueryParams,
} from "../../core/response";
import type {
  TruckVendorGroupPayload,
  TruckVendorListParams,
  TruckVendorPayload,
  TruckVendorSearchParams,
  UpdateTruckVendorGroupPayload,
} from "./types";

const getAllTruckVendorGroup = async (params: ServiceQueryParams) => {
  const response = await API.get("/admin/truck-vendor/group", {
    params,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "page");
  }
};

const getAllTruckVendor = async (params: TruckVendorListParams) => {
  const response = await API.get("/admin/truck-vendor", {
    params,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "current");
  }
};

const getAllTruckVendorSearch = async (params: TruckVendorSearchParams) => {
  const response = await API.get("/admin/truck-vendor/search", {
    params,
    silentLoading: true,
  }).then((res) => res.data);

  if (response.success) {
    return normalizePaginatedResponse(response, "current");
  }
};

const postCreateTruckVendorGroup = async (payload: TruckVendorGroupPayload) => {
  const response = await API.post("/admin/truck-vendor/group", payload).then(
    (res) => res.data,
  );
  return response;
};

const putUpdateTruckVendorGroup = async (
  payload: UpdateTruckVendorGroupPayload,
  id: string,
) => {
  const response = await API.put(
    `/admin/truck-vendor/group/${id}`,
    payload,
  ).then((res) => res.data);
  return response;
};

const postCreateTruckVendor = async (payload: TruckVendorPayload) => {
  const response = await API.post("/admin/truck-vendor", payload).then(
    (res) => res.data,
  );
  return response;
};

const putUpdateTruckVendor = async (payload: TruckVendorPayload, id: string) => {
  const response = await API.put(`/admin/truck-vendor/${id}`, payload).then(
    (res) => res.data,
  );
  return response;
};

const deleteTruckVendor = async (id: string) => {
  const response = await API.delete(`/admin/truck-vendor/${id}`).then(
    (res) => res.data,
  );
  return response;
};

const deleteTruckVendorGroup = async (id: string) => {
  const response = await API.delete(`/admin/truck-vendor/group/${id}`).then(
    (res) => res.data,
  );
  return response;
};

export default {
  getAllTruckVendorGroup,
  getAllTruckVendor,
  postCreateTruckVendorGroup,
  putUpdateTruckVendorGroup,
  deleteTruckVendorGroup,
  postCreateTruckVendor,
  putUpdateTruckVendor,
  deleteTruckVendor,
  getAllTruckVendorSearch,
};
